module.exports = __webpack_public_path__ + "img/20210122.2620c96e.png";